<script>
import JournalPay from '@/views/OutState/Components/JournalPay.vue';
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";

export default {
    components: {JournalPay},
    setup() {
        const {dialog} = useSharedData();
        const {getBack} = useSharedMethod();

        return {
            dialog,
            getBack
        }
    }
};
</script>

<template>
    <div>
        <v-dialog v-model="dialog" scrollable persistent max-width="1200">
            <v-card flat>
                <w-toolbar color="teal" :title="$t('pay_slip.journal')"/>
                <v-card-text>
                    <journal-pay :annex-id="$route.params.annexId"/>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>